import { QueryClient } from "@tanstack/react-query";
import {
  ActionItemDetailDto,
  ActionItemSummaryDto,
  GetPlanDto,
  GetUserStrategicOwnershipDto,
  queryKeys,
} from "src/http";
import { optimisticallyUpdateQueriesData, optimisticallyUpdateQueryData } from "../utilities";

export async function updateActionItemSummary(
  queryClient: QueryClient,
  actionItemGuid: string,
  updateFn: (item: ActionItemSummaryDto) => ActionItemSummaryDto,
) {
  return optimisticallyUpdateQueryData<ActionItemSummaryDto>(
    queryClient,
    queryKeys.actionItems.summary(actionItemGuid),
    updateFn,
  );
}

export async function updateActionItemDetail(
  queryClient: QueryClient,
  actionItemGuid: string,
  updateFn: (item: ActionItemDetailDto) => ActionItemDetailDto,
) {
  return optimisticallyUpdateQueryData<ActionItemDetailDto>(
    queryClient,
    queryKeys.actionItems.detail(actionItemGuid),
    updateFn,
  );
}

export async function updateActionItemInPlans(
  queryClient: QueryClient,
  actionItemGuid: string,
  updateFn: (item: ActionItemSummaryDto) => ActionItemSummaryDto,
) {
  return optimisticallyUpdateQueriesData<GetPlanDto>(
    queryClient,
    queryKeys.plans.allPlans,
    (cachedPlan) => ({
      ...cachedPlan,
      blocks: cachedPlan.blocks.map((block) => ({
        ...block,
        sections: block.sections.map((section) => ({
          ...section,
          actionItems: section.actionItems.map((item) => (item.guid === actionItemGuid ? updateFn(item) : item)),
        })),
      })),
    }),
    (plan) => plan.blocks.some((b) => b.sections.some((s) => s.actionItems.some((i) => i.guid === actionItemGuid))),
  );
}

export async function updateActionItemInUserOwnershipLists(
  queryClient: QueryClient,
  actionItemGuid: string,
  updateFn: (item: ActionItemSummaryDto) => ActionItemSummaryDto,
) {
  return optimisticallyUpdateQueriesData<GetUserStrategicOwnershipDto>(
    queryClient,
    queryKeys.actionItems.userOwnershipLists(), // All user ownership lists queries
    (cachedList) => ({
      ...cachedList,
      actionItems: cachedList.actionItems.map((item) => (item.guid === actionItemGuid ? updateFn(item) : item)),
    }),
    (list) => list.actionItems.some((item) => item.guid === actionItemGuid),
  );
}
